<template>
  <div id="pageRoot">
    <img
      id="title"
      src="/pages/img/sordovio/assets_p6/title.svg"
      style="width: 650px; margin-left: 80px; margin-top: 60px"
    />

    <span class="normalTheme pageInstruction" style="left: 62px; top: 150px">
      <p>
        Tacha los nombres de los instrumentos musicales que no perdió el
        grillito.
      </p>
    </span>

    <label class="imageCheckBoxWTag">
      <input
        type="checkbox"
        name="1"
        value="Piano"
        ref="1"
        v-on:click="saveOption('instrumentos', 1)"
        :onload="loadOption('instrumentos', 1)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 30px;
          margin-top: 275px;
          width: 300px;
          height: 400px;
        "
      >
        <div
          style="width: 100%; height: 70%; position: relative"
          class="imageContainer"
        >
          <img
            class="center"
            src="/pages/img/sordovio/assets_p6/piano.svg"
            style="width: 90%; max-height: 90%"
          />
        </div>
        <div style="width: 100%; height: 30%; position: relative">
          <div class="itemContainerTag textBase center">
            <p class="center">PIANO</p>
          </div>
        </div>
      </span>
    </label>

    <label class="imageCheckBoxWTag">
      <input
        type="checkbox"
        name="2"
        value="Tambor"
        ref="2"
        v-on:click="saveOption('instrumentos', 2)"
        :onload="loadOption('instrumentos', 2)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 370px;
          margin-top: 275px;
          width: 300px;
          height: 400px;
        "
      >
        <div
          style="width: 100%; height: 70%; position: relative"
          class="imageContainer"
        >
          <img
            class="center"
            src="/pages/img/sordovio/assets_p6/tambor.svg"
            style="width: 90%; max-height: 90%"
          />
        </div>
        <div style="width: 100%; height: 30%; position: relative">
          <div class="itemContainerTag textBase center">
            <p class="center">TAMBOR</p>
          </div>
        </div>
      </span>
    </label>

    <label class="imageCheckBoxWTag">
      <input
        type="checkbox"
        name="3"
        value="Guitarra"
        ref="3"
        v-on:click="saveOption('instrumentos', 3)"
        :onload="loadOption('instrumentos', 3)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 710px;
          margin-top: 275px;
          width: 300px;
          height: 400px;
        "
      >
        <div
          style="width: 100%; height: 70%; position: relative"
          class="imageContainer"
        >
          <img
            class="center"
            src="/pages/img/sordovio/assets_p6/guitarra.svg"
            style="width: 90%; max-height: 90%"
          />
        </div>
        <div style="width: 100%; height: 30%; position: relative">
          <div class="itemContainerTag textBase center">
            <p class="center">GUITARRA</p>
          </div>
        </div>
      </span>
    </label>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 9.mp4",
        "vio/Video 10.mp4",
        "vio/Video 11.mp4",
        "vio/Video 12.mp4",
        "vio/Video 13.mp4",
      ],
    };
  },
  methods: {
    dbId(name, option) {
      return `${this.$parent.pageID()}-${name}-${option}`;
    },
    async loadOption(name, option) {
      var id = this.dbId(name, option);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[option].checked = value.option;

      console.log("option loaded: " + id + ", " + value.option);
    },
    saveOption(name, option) {
      var id = this.dbId(name, option);
      var value = this.$refs[option].checked;

      this.$db.options
        .put({
          id: id,
          option: value,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + value);
    },
  },
  mounted() {},
};
</script>